//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class ResidenceClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param checkOwnership (optional) 
     * @param x_api_key (optional) 
     * @return Success
     */
    residence(checkOwnership: boolean | undefined, x_api_key: string | undefined, cancelToken?: CancelToken): Promise<CustomerResidenceDto[]> {
        let url_ = this.baseUrl + "/web/residence?";
        if (checkOwnership === null)
            throw new Error("The parameter 'checkOwnership' cannot be null.");
        else if (checkOwnership !== undefined)
            url_ += "checkOwnership=" + encodeURIComponent("" + checkOwnership) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "x-api-key": x_api_key !== undefined && x_api_key !== null ? "" + x_api_key : "",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResidence(_response);
        });
    }

    protected processResidence(response: AxiosResponse): Promise<CustomerResidenceDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerResidenceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CustomerResidenceDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerResidenceDto[]>(null as any);
    }

    /**
     * @param x_api_key (optional) 
     * @return Success
     */
    exist(x_api_key: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/web/residence/exist";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "x-api-key": x_api_key !== undefined && x_api_key !== null ? "" + x_api_key : "",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExist(_response);
        });
    }

    protected processExist(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class CustomerResidenceDto implements ICustomerResidenceDto {
    id?: number;
    address?: string | undefined;
    selected?: boolean;
    floor?: number;
    floorCode?: string | undefined;
    internIdAdresse?: string | undefined;
    postalCode?: string | undefined;
    municipalityName?: string | undefined;
    unitTypeName?: string | undefined;
    confirmedOwnership?: boolean;
    unitType?: string | undefined;
    numberOfOwnersOnLevel?: number;
    matrikkel?: ResidenceMatrikkelDto | undefined;
    size?: number;
    estimates?: CustomerResidenceEstimateDto[] | undefined;
    estimate?: CustomerResidenceEstimateDto | undefined;

    constructor(data?: ICustomerResidenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.address = _data["address"];
            this.selected = _data["selected"];
            this.floor = _data["floor"];
            this.floorCode = _data["floorCode"];
            this.internIdAdresse = _data["internIdAdresse"];
            this.postalCode = _data["postalCode"];
            this.municipalityName = _data["municipalityName"];
            this.unitTypeName = _data["unitTypeName"];
            this.confirmedOwnership = _data["confirmedOwnership"];
            this.unitType = _data["unitType"];
            this.numberOfOwnersOnLevel = _data["numberOfOwnersOnLevel"];
            this.matrikkel = _data["matrikkel"] ? ResidenceMatrikkelDto.fromJS(_data["matrikkel"]) : <any>undefined;
            this.size = _data["size"];
            if (Array.isArray(_data["estimates"])) {
                this.estimates = [] as any;
                for (let item of _data["estimates"])
                    this.estimates!.push(CustomerResidenceEstimateDto.fromJS(item));
            }
            this.estimate = _data["estimate"] ? CustomerResidenceEstimateDto.fromJS(_data["estimate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CustomerResidenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerResidenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["address"] = this.address;
        data["selected"] = this.selected;
        data["floor"] = this.floor;
        data["floorCode"] = this.floorCode;
        data["internIdAdresse"] = this.internIdAdresse;
        data["postalCode"] = this.postalCode;
        data["municipalityName"] = this.municipalityName;
        data["unitTypeName"] = this.unitTypeName;
        data["confirmedOwnership"] = this.confirmedOwnership;
        data["unitType"] = this.unitType;
        data["numberOfOwnersOnLevel"] = this.numberOfOwnersOnLevel;
        data["matrikkel"] = this.matrikkel ? this.matrikkel.toJSON() : <any>undefined;
        data["size"] = this.size;
        if (Array.isArray(this.estimates)) {
            data["estimates"] = [];
            for (let item of this.estimates)
                data["estimates"].push(item.toJSON());
        }
        data["estimate"] = this.estimate ? this.estimate.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICustomerResidenceDto {
    id?: number;
    address?: string | undefined;
    selected?: boolean;
    floor?: number;
    floorCode?: string | undefined;
    internIdAdresse?: string | undefined;
    postalCode?: string | undefined;
    municipalityName?: string | undefined;
    unitTypeName?: string | undefined;
    confirmedOwnership?: boolean;
    unitType?: string | undefined;
    numberOfOwnersOnLevel?: number;
    matrikkel?: ResidenceMatrikkelDto | undefined;
    size?: number;
    estimates?: CustomerResidenceEstimateDto[] | undefined;
    estimate?: CustomerResidenceEstimateDto | undefined;
}

export class CustomerResidenceEstimateDto implements ICustomerResidenceEstimateDto {
    estimatedValue?: number;

    constructor(data?: ICustomerResidenceEstimateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.estimatedValue = _data["estimatedValue"];
        }
    }

    static fromJS(data: any): CustomerResidenceEstimateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerResidenceEstimateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["estimatedValue"] = this.estimatedValue;
        return data;
    }
}

export interface ICustomerResidenceEstimateDto {
    estimatedValue?: number;
}

export class ResidenceMatrikkelDto implements IResidenceMatrikkelDto {
    municipalityNumber?: number | undefined;
    farmNumber?: number | undefined;
    usageNumber?: number | undefined;
    leaseNumber?: number | undefined;
    sectionNumber?: number | undefined;

    constructor(data?: IResidenceMatrikkelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.municipalityNumber = _data["municipalityNumber"];
            this.farmNumber = _data["farmNumber"];
            this.usageNumber = _data["usageNumber"];
            this.leaseNumber = _data["leaseNumber"];
            this.sectionNumber = _data["sectionNumber"];
        }
    }

    static fromJS(data: any): ResidenceMatrikkelDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResidenceMatrikkelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["municipalityNumber"] = this.municipalityNumber;
        data["farmNumber"] = this.farmNumber;
        data["usageNumber"] = this.usageNumber;
        data["leaseNumber"] = this.leaseNumber;
        data["sectionNumber"] = this.sectionNumber;
        return data;
    }
}

export interface IResidenceMatrikkelDto {
    municipalityNumber?: number | undefined;
    farmNumber?: number | undefined;
    usageNumber?: number | undefined;
    leaseNumber?: number | undefined;
    sectionNumber?: number | undefined;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}